import styled, { css } from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "r30sel-0"
})(["", " color:", ";", " font-size:", ";font-weight:", ";margin-right:1.5rem;"], function (_ref) {
  var isActive = _ref.isActive;
  return isActive && css(["border-bottom:3px solid ", ";"], function (_ref2) {
    var palette = _ref2.theme.palette;
    return palette.primary["default"];
  });
}, function (_ref3) {
  var isActive = _ref3.isActive,
      isDisabled = _ref3.isDisabled,
      palette = _ref3.theme.palette;
  return isActive ? palette.darkBlue : isDisabled ? palette.mediumGrey : palette.spaceGrey;
}, function (_ref4) {
  var isActive = _ref4.isActive,
      isDisabled = _ref4.isDisabled;
  return !isActive && !isDisabled && css(["cursor:pointer;"]);
}, function (_ref5) {
  var fonts = _ref5.theme.fonts;
  return fonts.size.h6;
}, function (_ref6) {
  var isActive = _ref6.isActive,
      weight = _ref6.theme.fonts.weight;
  return isActive ? weight.thick : weight.normal;
});